module.exports = ({React,DataGrid,FormGroup,Typeahead,Api})=>

  class UserDownloadsTab extends React.Component

    constructor:(props)->
      super(props)
      @state = {downloads:[],selected:[],available:[],chosen:{},saving:false}
      @columns = [
        {label:"Ref",field:"id",width:110},
        {label:"Title",field:"title",width:500},
        {label:"Purchased",field:"purchased",width:50, type:"tick"}
        {label:"Enabled",field:"enabled",width:50, type:"tick"}
      ]

    componentDidMount:->
      if @props.user?.id
        @loadProducts()
        @loadDownloads(@props.user.id) if @props.user.id

    componentDidUpdate:(prev_props)->
      if @props.user?.id && @props.user!=prev_props.user
        @loadProducts()
        @loadDownloads(@props.user.id) if @props.user.id
    
    loadProducts:->
      fetch("/duocms/api/nafemsdownloads")
      .then (res)=>
        data = res.json()
      .then (res)=>
        @setState({available:res.data})

    loadDownloads:(user_id)->
      fetch("/duocms/api/nafemsdownloads/"+user_id)
      .then (res)=>
        data = res.json()
      .then (res)=>
        @setState({downloads:res.data})

    chooseDownload:(chosen)=>
      @setState({chosen:chosen})

    addDownload:=>
      if @state.chosen?.id
        console.log("Adding",@state.chosen.id)
        # post addition to db here, then reload
        @setState({saving:true})
        fetch("/duocms/api/nafemsdownloads/",{
          headers: new Headers({'content-type': 'application/json','X-CSRF-Token':window._csrf}),credentials: 'same-origin',
          method: "POST",
          body: JSON.stringify({user_id:@props.user.id,product_id:@state.chosen.id})
        }).then (res)=>
          @setState({chosen:{},saving:false})
          data = res.json()
        .then (res)=>
          @setState({downloads:res.data})
        .catch (err)=>
          @setState({saving:false})

    removeDownload:=>
      # if a non purchased download is selected, enable the remove download button
      fetch("/duocms/api/nafemsdownloads/"+@state.selected[0].download_id,{
        headers: new Headers({'content-type': 'application/json','X-CSRF-Token':window._csrf}),credentials: 'same-origin', method: "DELETE"
      }).then (res)=>
        @setState({selected:[]})
        @loadDownloads(@props.user.id)

    enableDownload:=> @updateDownload(true)

    disableDownload:=> @updateDownload(false)

    updateDownload:(enabled)=>
      # if a non purchased download is selected, enable the remove download button
      if @state.selected[0].download_id && @state.selected[0].puchased == true 
        url = "/duocms/api/nafemsdownloads/"+@state.selected[0].download_id
        method = "DELETE"
      else if @state.selected[0].download_id
        url = "/duocms/api/nafemsdownloads/"+@state.selected[0].download_id
        method = "PUT"
      else 
        url = "/duocms/api/nafemsdownloads"
        method = "POST"

      fetch(url,{
        headers: new Headers({'content-type': 'application/json','X-CSRF-Token':window._csrf}),credentials: 'same-origin', 
        method: method,
        body: JSON.stringify({
          product_id:@state.selected[0].product_id,
          enabled:enabled,
          transaction_id:@state.selected[0].transaction_id
          user_id:@props.user.id
        })
      }).then (res)=>
        @setState({selected:[]})
        @loadDownloads(@props.user.id)

    render:->
      <div>
        <div class="form-horizontal">
          <FormGroup label="Add Download" key="name">
            <div class="input-group">
              <Typeahead value={@state.chosen.id} placeholder="type name of download to search products database" options={@state.available} max={5} label="name" onChange={(chosen)=> @chooseDownload(chosen)} />
              <div class="input-group-btn">
                <button class="btn btn-primary" disabled={!@state.chosen?.id || @state.saving} onClick={@addDownload}>Add</button>
              </div>
            </div>
          </FormGroup>
        </div>        
        <div style={{ height: 400,margin:"10px 0 30px 0",border:"1px solid #eee" }} className="downloads_list">
          <DataGrid 
            rows={@state.downloads} 
            columns={@columns}
            selected={@state.selected}
            onRowClick={(selectedRows)=> @setState({selected:selectedRows})}
          />
          <div className="react-grid-FooterRow">{@state.downloads.length} Downloads</div>
        </div>
        <div class="btn-toolbar">
          <button className="btn btn-default" onClick={@removeDownload} disabled={!@state.selected.length || @state.selected[0].transaction_id}>Remove Selected Download</button>
          {if @state.selected?[0]?.enabled
            <button className="btn btn-default" onClick={@disableDownload} disabled={!@state.selected.length}>Disable Download</button>
          else 
            <button className="btn btn-default" onClick={@enableDownload} disabled={!@state.selected.length}>Enable Download</button>
          }
        </div>
        
      </div>
  
      